import type { CSSProperties, FC } from "react";
import { space } from "../../../design-tokens";

interface CustomProgressBarProps {
    value: number;
}

const progressBarStyle: CSSProperties = {
    position: "absolute",
    bottom: space["0.2"],
    width: "100%",
    height: space[1],
    backgroundColor: "transparent",
    zIndex: 1,
};

export const CustomProgressBar: FC<CustomProgressBarProps> = ({ value }) => {
    return (
        <div style={progressBarStyle}>
            <div
                style={{
                    width: `${value}%`,
                    height: "100%",
                    backgroundColor: "#EEEE",
                    transition: "width 1s ease",
                }}
            ></div>
        </div>
    );
};
